export default "__VITE_ASSET__BMm$xipU__"